import React, {useEffect, useMemo, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {AuthenticationApiCalls} from "../../apis/AuthenticationApiCalls";
import {PollApiCalls} from "../../apis/PollApiCalls";
import YuJaGeneralAlert from "../../components/modals/YuJaGeneralAlert";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {
    ACTIVITY_EDITOR_VIEW,
    AUDIENCE_RESTRICTION,
    CREATE_POLL_PATH,
    HOME_PATH,
    POLL_SHARE_MODE,
    POLL_TITLE_LENGTH,
    POLL_TYPE,
    QUESTION_MAX_POINTS,
    QUESTION_TYPES,
    SYNC_LMS_OPTIONS,
    USER_SETTINGS
} from "../../utils/constants";
import {
    generateDefaultAttendanceTitle, generateDefaultPollTitle, getActivityAudienceRestriction,
    getDefaultUserSettings, getQuestionWeightage, isShareByQuestionActivity,
    notifyError,
    removePrefix, removePrefixNew,
    transferUserSettings,
    updateCreateMode,
    validateText
} from "../../utils/helpers";
import {
    addQuestion,

    questionError,
    setBlankRestriction,
    trimLineBreakerInQuestion,
    trimQuestion
} from "../../utils/questionUtils";
import "./styles.css";
import {useImageLoaderManager} from "../../hooks/useImageLoaderManager";
import useNavigationGuard from "../../hooks/useNavigationGuard";
import classes from "./ActivityEditor.module.css";
import ActivityEditorTitleContainer from "./ActivityEditorTitleContainer";
import ActivityEditorDashboard from "./ActivityEditorDashboard";
import ActivityEditorMainView from "./ActivityEditorMainView";
import ActivityEditorSaved from "./ActivityEditorSaved";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import {CourseApiCalls} from "../../apis/CourseApiCalls";
import ActivityEditorImportQuestions from "./ActivityEditorImportQuestions";
import { useTranslation } from "react-i18next";

export default function CreateQuizPage({
                                           setPollKeyCode,
                                           setPageIdentifier
                                       }) {
    const { t } = useTranslation();
    const [, getSession] = useLocalStorageNew("session", {});
    const { saveAndPublish, softDeleteDraftPoll} = PollApiCalls();
    const {logout} = AuthenticationApiCalls();
    const {takeScreenshotsNew, warmUpBrowser} = ReportApiCalls();
    const {getCourseByUser} = CourseApiCalls();
    const history = useHistory();
    const location = useLocation();
    const session = getSession();
    const [userSettings, setUserSettings] = useState(getDefaultUserSettings());
    const {
        correctConfigurations,
        verifyConfiguration,
        isLMS,
    } = useSynLMSConfiguration();

    const [pollCode, setPollCode] = useState("");
    const [currQueDisplay, setCurrQueDisplay] = useState(1);
    const [courseList, setCourseList] = useState([]);

    const [focusMCElem, setFocusMCElem] = useState(-1);
    const [focusSAElem, setFocusSAElem] = useState(-1);
    const [focusTFElem, setFocusTFElem] = useState(-1);
    const [focusFITBElem, setFocusFITBElem] = useState(-1);
    const [focusCIElem, setFocusCIElem] = useState(-1);
    const [focusMHElem, setFocusMHElem] = useState(-1);
    const [focusRKElem, setFocusRKElem] = useState(-1);
    const [isSaving, setIsSaving] = useState(false);
    const [focusWCElem, setFocusWCElem] = useState(-1);
    const [setSaveExit, getsaveExit] = useLocalStorageNew("saveExit", false);
    const [setRecentActivity, getRecentActivity] = useLocalStorageNew("recentActivity", {});
    const [setTempPollKey, ] = useLocalStorageNew("activity_creation_temp_pollKey", "");
    // const [setShowAnswer, getShowAnswer] = useLocalStorageNew("showAnswer", false);
    const [dataLoading, setDataLoading] = useState(true);
    const [isAutoSaving, setIsAutoSaving] = useState(null);
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);

    const [savedActivity, setSavedActivity] = useState({});
    const [draftActivity, setDraftActivity] = useState({});
    const [editorView, setEditorView] = useState(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [hasClicked, setHasClicked] = useState(false);

    const setQuestions = (questions) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.questions = questions;
        setDraftActivity(copy);
    }

    const {checkAnyQuestionIsLoading} = useImageLoaderManager(draftActivity.questions, setQuestions);

    const initializeQuestions = async () => {
        warmUpBrowser("", "", "").then();


        let {settings = {}, } = session;

        settings = transferUserSettings(settings);
        setUserSettings(settings);

        const recentActivity = getRecentActivity();
        await loadCourse();

        let activity = {};
        activity.pollKey = recentActivity.pollKey;
        activity.pollTitle = !!recentActivity.pollTitle ? recentActivity.pollTitle : generateDefaultTitle();
        activity.pollType = location.state.pollType;
        activity.gradeSchema = recentActivity.gradeSchema;
        activity.pollShareMode = POLL_SHARE_MODE.UNKNOWN;
        activity.pollDescription = recentActivity.pollDescription;
        activity.pollTimeLimit = recentActivity.hasOwnProperty("pollTimeLimit") ? recentActivity.pollTimeLimit : settings[USER_SETTINGS.POLL_DURATION];
        activity.pollBreakDuration = recentActivity.hasOwnProperty("pollBreakDuration") ? recentActivity.pollBreakDuration : settings[USER_SETTINGS.POLL_BREAK_DURATION];
        activity.getReadyAllTimeLimit = recentActivity.hasOwnProperty("getReadyAllTimeLimit") ? recentActivity.getReadyAllTimeLimit : settings[USER_SETTINGS.POLL_COUNTDOWN];
        activity.recordAttempt = recentActivity.hasOwnProperty("recordAttempt") ? recentActivity.recordAttempt : settings[USER_SETTINGS.POLL_RECORD_ATTEMPTS];
        activity.lmsAttempt = recentActivity.hasOwnProperty("lmsAttempt") ? recentActivity.lmsAttempt : settings[USER_SETTINGS.POLL_LMS_SYNC];
        activity.maxAttempts = recentActivity.hasOwnProperty("maxAttempts") ? recentActivity.maxAttempts : settings[USER_SETTINGS.POLL_MAX_ATTEMPTS];
        activity.showAnswerOnViewer = recentActivity.hasOwnProperty("showAnswerOnViewer") ? recentActivity.showAnswerOnViewer : settings[USER_SETTINGS.POLL_SHOW_CORRECT_ANS];
        activity.audienceRestriction = getActivityAudienceRestriction(recentActivity, settings);
        activity.pptAutoShare = recentActivity.hasOwnProperty("pptAutoShare") ? recentActivity.pptAutoShare :  settings[USER_SETTINGS.PPT_AUTO_SHARE];
        activity.manualEnd = recentActivity.hasOwnProperty("manualEnd") ? recentActivity.manualEnd : settings[USER_SETTINGS.ATTENDANCE_MANUAL_END];
        activity.lmsRedirectUrl = recentActivity.lmsRedirectUrl;
        activity.D2LModuleId = recentActivity.D2LModuleId;
        activity.moodleSectionId = recentActivity.moodleSectionId;
        activity.courseId = removePrefix(recentActivity.courseId);

        if (recentActivity.hasOwnProperty("syncLms")) {
            activity.syncLms = recentActivity.syncLms;
            activity.syncLmsOption = recentActivity.syncLmsOption;
        }

        // else {
        //     const {syncLms, syncLmsOption, courseId, audienceRestriction} = getDefaultConfiguration(courseOptions);
        //     activity.syncLms = syncLms;
        //     activity.syncLmsOption = syncLmsOption;
        //     activity.courseId = courseId;
        //     activity.audienceRestriction = !!audienceRestriction ? audienceRestriction : activity.audienceRestriction;
        // }

        // let defaultModuleId = await loadModulesAndGetDefaultId(activity.courseId);
        //
        // if (!activity.D2LModuleId || activity.D2LModuleId === "-1") {
        //     activity.D2LModuleId = defaultModuleId;
        // }


        if (activity.pollType === POLL_TYPE.ATTENDANCE) {
            if (recentActivity.pollType !== POLL_TYPE.ATTENDANCE
                || !recentActivity.hasOwnProperty("questions")
                || recentActivity.questions.length !== 1
                || recentActivity.questions[0].questionType !== QUESTION_TYPES.SA.name
            ) {
                const qs = addQuestion([], QUESTION_TYPES.SA.name, settings, false, POLL_TYPE.ATTENDANCE);
                activity.questions = qs;
            } else {
                activity.questions = recentActivity.questions;
            }
            activity.geofence = recentActivity.hasOwnProperty("geofence") ? recentActivity.geofence : {};
            activity.attendanceDuration = recentActivity.hasOwnProperty("attendanceDuration") ? recentActivity.attendanceDuration : settings[USER_SETTINGS.ATTENDANCE_DURATION];
            setEditorView(isLMS()
                ? (!Object.keys(recentActivity).length ? ACTIVITY_EDITOR_VIEW.OVERVIEW : ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING)
                : ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING);
            updateCreateMode(POLL_TYPE.MERGED_POLL);
            if (!recentActivity.hasOwnProperty("syncLms") && !isLMS()) {
                activity.syncLms = false;
            }

        } else {
            activity.questions = !!recentActivity.questions && !!recentActivity.questions.length ? JSON.parse(JSON.stringify(recentActivity.questions)) : [{serialNo: 1}];
            setBlankRestriction(activity.questions);
            setEditorView(!!activity.gradeSchema ? ACTIVITY_EDITOR_VIEW.QUESTION_EDITING : ACTIVITY_EDITOR_VIEW.OVERVIEW);
        }

        setSavedActivity(activity);
        setDraftActivity(JSON.parse(JSON.stringify(activity)));
        setCurrQueDisplay(1);

        setPageIdentifier(activity.pollType === POLL_TYPE.ATTENDANCE ? t("attendance.createAttendanceText") : t("poll.createPollText"));

        setDataLoading(false);
    }

    useEffect(() => {
        if (!!Object.entries(draftActivity).length) {
            setRecentActivity(draftActivity);
        }


        if (draftActivity.pollType === POLL_TYPE.MERGED_POLL) {

            if (!draftActivity.gradeSchema
                || !draftActivity.questions
                || !draftActivity.questions.length
                || !draftActivity.questions.filter(q => !!q.questionType).length
            ) {
                setSaveBtnDisabled(true);
            } else {
                setSaveBtnDisabled(false);
            }

        }
    }, [draftActivity]);

    const loadCourse = async () => {
        const {idpType="", intType=""} = session;
        const courses = await getCourseByUser(idpType, intType);
        const options = courses.map(course => ({
            value: course.courseId,
            label: course.courseName,
            code: course.courseCode,
            isLmsCourse: !!course.index3Pk,
            lmsCourseId: removePrefixNew(!!course.index3Pk ? course.index3Pk : "")
        }));
        setCourseList(options);

        return options;
    }
    const hasUnsavedChanges = useMemo(
        () => JSON.stringify(draftActivity) !== JSON.stringify(savedActivity) && getsaveExit() !== true,
        [draftActivity, savedActivity, getsaveExit],
    );

    const {
        showConfirm: alertShow,
        confirmationModal: leaveConfirmationModal,
    } = useNavigationGuard({
        hasUnsavedChanges,
        onBypass: (location) => {
            setSaveExit(false);
            resetPoll();
            if (location && location.state && location.state.logout) {
                logout();
            }
        },
        onConfirm: (location) => {
            resetPoll();
            if (location && location.state && location.state.logout) {
                logout();
                return false;
            }
            return true;
        },
    });

    // useEffect(() => {
    //     setTimeout(() => {
    //         if (questions.length < currQueDisplay) {
    //             return;
    //         }
    //         switch (questions[currQueDisplay - 1].questionType) {
    //             case QUESTION_TYPES.MCSS.name:
    //                 if (focusMCElem !== -1) {
    //                     document.getElementsByName("question-text")[focusMCElem].focus();
    //                     setFocusMCElem(-1);
    //                 }
    //                 break;
    //             case QUESTION_TYPES.SA.name:
    //             case QUESTION_TYPES.IB.name:
    //             case QUESTION_TYPES.RETRO.name:
    //             case QUESTION_TYPES.BS.name:
    //                 if (focusSAElem !== -1) {
    //                     document.getElementsByName("question-text")[focusSAElem].focus();
    //                     setFocusSAElem(-1);
    //                 }
    //                 break;
    //             case QUESTION_TYPES.TF.name:
    //                 if (focusTFElem !== -1) {
    //                     document.getElementsByName("question-text")[focusTFElem].focus();
    //                     setFocusTFElem(-1);
    //                 }
    //                 break;
    //             case QUESTION_TYPES.FITB.name:
    //                 if (focusFITBElem !== -1) {
    //                     if (focusFITBElem === 0) {
    //                         document.getElementsByClassName("notranslate public-DraftEditor-content")[focusFITBElem].focus();
    //                     } else {
    //                         document.getElementsByName("question-text")[focusFITBElem - 1].focus();
    //                     }
    //                     setFocusFITBElem(-1);
    //                 }
    //                 break;
    //             case QUESTION_TYPES.CI.name:
    //                 if (focusCIElem !== -1) {
    //                     document.getElementsByName("question-text")[focusCIElem].focus();
    //                     setFocusCIElem(-1);
    //                 }
    //                 break;
    //
    //             case QUESTION_TYPES.MH.name:
    //                 if (focusMHElem !== -1) {
    //                     document.getElementsByName("question-text")[focusMHElem].focus();
    //                     setFocusMHElem(-1);
    //                 }
    //                 break;
    //             case QUESTION_TYPES.RK.name:
    //                 if (focusRKElem !== -1) {
    //                     console.log(focusRKElem);
    //                     document.getElementsByName("question-text")[focusRKElem].focus();
    //                     setFocusRKElem(-1)
    //                 }
    //                 break;
    //             case QUESTION_TYPES.WC.name:
    //                 if (focusWCElem !== -1) {
    //                     console.log(focusWCElem);
    //                     document.getElementsByName("question-text")[focusWCElem].focus();
    //                     setFocusWCElem(-1);
    //                 }
    //                 break;
    //         }
    //     }, 500);
    // }, [currQueDisplay, focusMCElem, focusSAElem, focusTFElem, focusFITBElem, focusCIElem, focusMHElem, focusWCElem, focusRKElem]);

    const validatePoll = (draft, focusError = true) => {
        if (!validateText(draft.pollTitle, POLL_TITLE_LENGTH)) {
            if (focusError) {
                notifyError(t("activity.titleError"));
                // document.getElementsByName("pollTitle")[0].focus();
            }
            return false;
        }

        if (draft.pollType !== POLL_TYPE.ATTENDANCE && !draft.hasOwnProperty("gradeSchema")) {
            notifyError(t("activity.typeMissingError"));
            setEditorView(ACTIVITY_EDITOR_VIEW.OVERVIEW);
            return false;
        }

        if (draft.syncLmsOption !== SYNC_LMS_OPTIONS.EMBEDDED
            && draft.audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED
            && !draft.courseId
        ) {
            setEditorView(ACTIVITY_EDITOR_VIEW.CONFIGURATION);
            notifyError(t("sharePoll.selectCourseMessage"));
            return false;
        }

        let i = 0;
        for (let q of draft.questions) {
            i++;
            if (getQuestionWeightage(q) > QUESTION_MAX_POINTS) {
                if (focusError) {
                    let errorWithQuestion = t("accessibility.questionPrefix") + " " + i + ": " + t("questionBuilder.maxPointsExceeded");
                    notifyError(errorWithQuestion);
                    setCurrQueDisplay(q.serialNo);
                    setEditorView(draft.pollType === POLL_TYPE.ATTENDANCE
                        ? ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING
                        : ACTIVITY_EDITOR_VIEW.QUESTION_EDITING
                    );
                }
                return false;
            }
        }

        let index = 0;
        for (let q of draft.questions) {
            index++;
            if (focusError) setCurrQueDisplay(q.serialNo);
            let {quesError, elemIndex} = questionError(q, draft.pollType, draft.gradeSchema);
            switch (q.questionType) {
                case QUESTION_TYPES.MCSS.name:
                    if (focusError) {
                        setFocusMCElem(elemIndex)
                    }
                    break;
                case QUESTION_TYPES.SA.name:
                case QUESTION_TYPES.IB.name:
                case QUESTION_TYPES.RETRO.name:
                case QUESTION_TYPES.BS.name:
                    if (focusError) {
                        setFocusSAElem(elemIndex);
                    }
                    break;
                case QUESTION_TYPES.TF.name:
                    if (focusError) {
                        setFocusTFElem(elemIndex);
                    }
                    break;
                case QUESTION_TYPES.FITB.name:
                    if (focusError) {
                        setFocusFITBElem(elemIndex);
                    }
                    break;
                case QUESTION_TYPES.CI.name:
                    if (focusError) {
                        setFocusCIElem(elemIndex);
                    }
                    break;
                case QUESTION_TYPES.MH.name:
                    if (focusError) {
                        setFocusMHElem(elemIndex);
                    }
                    break;
                case QUESTION_TYPES.WC.name:
                    if (focusError) {
                        setFocusWCElem(elemIndex);
                    }
                    break;
                case QUESTION_TYPES.RK.name:
                    if (focusError) {
                        setFocusRKElem(elemIndex);
                    }
                    break;
            }

            if (quesError) {
                if (focusError) {
                    let errorWithQuestion = t("accessibility.questionPrefix") + " " + index + ": " + quesError;
                    // setQuestions(chooseQuestion(q.serialNo, questions));
                    setCurrQueDisplay(q.serialNo);
                    setEditorView(draft.pollType === POLL_TYPE.ATTENDANCE
                        ? ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING
                        : ACTIVITY_EDITOR_VIEW.QUESTION_EDITING
                    );
                    notifyError(errorWithQuestion);
                }
                return false;
            }
        }
        return true;
    };


    const savePoll = async (updatedQuestions = []) => {

        let generatedTitle = generateDefaultPollTitle();

        let pollToAdd = JSON.parse(JSON.stringify(draftActivity));
        let questionsCopy = updatedQuestions && updatedQuestions.length > 0 ? JSON.parse(JSON.stringify(updatedQuestions)) : pollToAdd.questions;


        for (const que of questionsCopy) {
          trimLineBreakerInQuestion(que);
        }

        if (pollToAdd.pollType !== POLL_TYPE.ATTENDANCE) {
            pollToAdd.questions = trimQuestion(questionsCopy, draftActivity.gradeSchema);
        }

        pollToAdd.pollTitle = !!pollToAdd.pollTitle ? pollToAdd.pollTitle : generatedTitle;
        pollToAdd = correctConfigurations(pollToAdd);

        let result = await saveAndPublish(pollToAdd, false);
        if (!result) {
            return false;
        }

        let {draft = {}, published, uniqueCode} = result;
        published = !!published ? published : {};
        const {isValid, pk, sk, totalQuestions} = published;
        let pollKeyTemp = removePrefix(draft.pollKey);

        if (!!isValid) {
            takeScreenshotsNew(
                removePrefixNew(pk),
                removePrefixNew(sk),
                isShareByQuestionActivity(published),
                Array.from({ length: totalQuestions }, (_, i) => ({ serialNo: i + 1 }))
            );
        }

        if (uniqueCode) {
            setPollCode(pollCode);
            setPollKeyCode(`${pollKeyTemp}/${uniqueCode}`);
        } else {
            setPollKeyCode(`${pollKeyTemp}/${t("poll.draftLabel")}`);
        }

        const copy = JSON.parse(JSON.stringify(draftActivity));
        if (pollToAdd.pollKey !== pollKeyTemp
            || pollToAdd.pollTitle !== draftActivity.pollTitle
            || (updatedQuestions && updatedQuestions.length > 0)
        ) {
            if (pollToAdd.pollKey !== pollKeyTemp) {
                copy.pollKey = pollKeyTemp;
            }

            if (pollToAdd.pollTitle !== draftActivity.pollTitle) {
                copy.pollTitle = pollToAdd.pollTitle;
            }

            if (updatedQuestions && updatedQuestions.length > 0) {
                copy.questions = updatedQuestions;
            }

            setDraftActivity(copy);
            setSavedActivity(JSON.parse(JSON.stringify(copy)))
        } else {
            setSavedActivity(copy)
        }


        window.onbeforeunload = undefined;
        return true;
    };


    const savePollClose = () => {
        let pollToAdd = JSON.parse(JSON.stringify(draftActivity));
        let questionsCopy = pollToAdd.questions;

        if (pollToAdd.pollType !== POLL_TYPE.ATTENDANCE) {
            questionsCopy = trimQuestion(questionsCopy, draftActivity.gradeSchema);
        }
        for (const que of questionsCopy) {
            trimLineBreakerInQuestion(que);
        }
        pollToAdd.questions = questionsCopy;
        pollToAdd = correctConfigurations(pollToAdd);

        if (!validatePoll(pollToAdd)) {
            return;
        }

        let error = verifyConfiguration(pollToAdd);
        if (!!error) {
            notifyError(error);
            setEditorView(ACTIVITY_EDITOR_VIEW.OVERVIEW);
            return;
        }

        setIsSaving(true);

        saveAndPublish(pollToAdd).then((result) => {
            if (!result) {
                return;
            }

            let {draft = {}, published={}, uniqueCode} = result;
            published = !!published ? published : {};
            const {isValid, pk, sk, totalQuestions} = published;

            let pollKeyTemp = removePrefix(draft.pollKey);

            if (!!isValid) {
                takeScreenshotsNew(
                    removePrefixNew(pk),
                    removePrefixNew(sk),
                    isShareByQuestionActivity(published),
                    Array.from({ length: totalQuestions }, (_, i) => ({ serialNo: i + 1 }))
                );
            }


            if (pollToAdd.pollKey !== pollKeyTemp) {
                pollToAdd.pollKey = pollKeyTemp;
            }

            pollToAdd.syncLms = draft.syncLms;
            pollToAdd.syncLmsOption = draft.syncLmsOption;
            pollToAdd.lmsHomeUrl = draft.lmsHomeUrl;
            pollToAdd.audienceRestriction = draft.audienceRestriction;
            pollToAdd.courseId = removePrefix(draft.courseId);



            setSavedActivity(pollToAdd);
            setDraftActivity(JSON.parse(JSON.stringify(pollToAdd)));
            setPollKeyCode(`${pollKeyTemp}/${uniqueCode}`);
            setSaveExit(true);
            setPollCode(uniqueCode);
            setEditorView(ACTIVITY_EDITOR_VIEW.SAVE_SUCCESS);
        }).finally(() => {
            setIsSaving(false);
        });
    };

    useEffect(() => {
        return () => {
            window.onbeforeunload = undefined;
        };
    }, []);

    const resetPoll = () => {
        // window.onbeforeunload = undefined;
        // window.location = window.location.href;
        setIsSaving(false);
        // setPollCode();
        setRecentActivity({});
        setTempPollKey("");
        // setType(pollType);
        // history.push({pathname: "/create", state : { pollType : pollType }})
    }


    useEffect(() => {
        if (!history.location.state || !history.location.state.previous || history.location.state.previous !== location.pathname) {
            resetPoll();
            if (history.location.state && history.location.state.pollType) {
                console.log("resetting poll type", history.location.state.pollType);
                history.replace({
                    pathname: CREATE_POLL_PATH,
                    state: {
                        pollType: [t("poll.gradedPollLabel"), POLL_TYPE.GRADED_POLL, t("poll.surveyLabel"), POLL_TYPE.SURVEY].includes(history.location.state.pollType) ?
                            POLL_TYPE.MERGED_POLL :
                            history.location.state.pollType,
                        fromNavbar: true,
                        previous: CREATE_POLL_PATH
                    }
                });
            } else {
                console.log("resetting to default poll type", POLL_TYPE.MERGED_POLL)
                history.replace({
                    pathname: CREATE_POLL_PATH,
                    state: {pollType: POLL_TYPE.MERGED_POLL, fromNavbar: true, previous: CREATE_POLL_PATH}
                })
            }
        }
        setDataLoading(true);
        initializeQuestions();
        // const questitle = getPollTitle(); // changing poll type or creating new poll/survey should not retain title
        // if (questitle != "") {
        //   setTitle(questitle);
        // }

        // const showAnswer = getShowAnswer();
        // setShowAnswerOnViewer(showAnswer);
    }, [location]);



    const generateDefaultTitle = () => {
        if (draftActivity.pollType === POLL_TYPE.ATTENDANCE) {
            return generateDefaultAttendanceTitle();
        } else {
            return generateDefaultPollTitle();
        }
    }



    useEffect(() => {
        if (!!alertShow || !!isSaving || !!showDeleteModal) {
            return;
        }
        if (draftActivity.pollType === POLL_TYPE.ATTENDANCE) {
            return;
        }

        if (checkAnyQuestionIsLoading()) {
            return;
        }

        const interval = setInterval(() => {
            if (JSON.stringify(draftActivity) !== JSON.stringify(savedActivity)) {
                setIsAutoSaving(true);
                savePoll().finally(() => setIsAutoSaving(false));
            }
        }, 10000);
        return () => clearInterval(interval);
    }, [draftActivity, savedActivity, alertShow, showDeleteModal, isSaving]);



    const deletePollConfig = {
        title: t("poll.deleteActivityTitle"),
        okText: t("common.delete"),
        cancelText: t("common.cancel"),
        submit: () => {
            if (!draftActivity.pollKey) {
                resetPoll();
                if (history.length > 2) {
                    history.goBack();
                } else {
                    history.push(HOME_PATH);
                }
                return;
            }

            softDeleteDraftPoll(draftActivity.pollKey, draftActivity.pollType).then(() => {
                if (history.length > 2) {
                    history.goBack();
                } else {
                    history.push(HOME_PATH);
                }
            });
        },
        close: () => {
            setShowDeleteModal(false);
        },
    };

    if (editorView === ACTIVITY_EDITOR_VIEW.SAVE_SUCCESS) {
        return (
            <ActivityEditorSaved pollKey={draftActivity?.pollKey} pollCode={pollCode}/>
        );
    } else if (editorView === ACTIVITY_EDITOR_VIEW.IMPORT_QUESTIONS) {
        return (
            <ActivityEditorImportQuestions
                setEditorView={setEditorView}
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                courseList={courseList}
                userSettings={userSettings}
            />
        );
    }


    return (
        <>
            {leaveConfirmationModal}

            <YuJaGeneralAlert
                show={showDeleteModal}
                setModalShow={setShowDeleteModal}
                content={t("poll.deleteActivityModalBody")}
                config={deletePollConfig}
                AlertType={t("common.delete")}
            />

            <div className={`${classes.parentContainer} ${ classes.gridLayout}`}>
                <ActivityEditorTitleContainer
                    generateTitle={generateDefaultTitle}
                    dataLoading={dataLoading}
                    draftActivity={draftActivity}
                    setDraftActivity={setDraftActivity}
                    userSettings={userSettings}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    isAutoSaving={isAutoSaving}
                    isSaving={isSaving}
                    saveBtnDisabled={saveBtnDisabled}
                    handleSave={savePollClose}
                    setShowDeleteModal={setShowDeleteModal}
                    editorView={editorView}
                    setEditorView={setEditorView}
                />

                <ActivityEditorDashboard
                    dataLoading={dataLoading}
                    editorView={editorView}
                    setEditorView={setEditorView}
                    draftActivity={draftActivity}
                    setQuestions={setQuestions}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    userSettings={userSettings}
                />


                <ActivityEditorMainView
                    userSettings={userSettings}
                    dataLoading={dataLoading}
                    editorView={editorView}
                    setEditorView={setEditorView}
                    draftActivity={draftActivity}
                    setDraftActivity={setDraftActivity}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    savePoll={savePoll}
                    courseList={courseList}
                    hasClicked={hasClicked}
                    setHasClicked={setHasClicked}
                />
            </div>
        </>
    );
}
